import './App.css';
import { Suspense, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import '../src/resources/css/common.css';

import LoginPage from './views/Login/Login';
import GroupPage from './views/Group/Group';
import ProductPage from './views/Product/Product';
import ServiceUserPage from './views/ServiceUser/ServiceUser';
import Init from "./views/Login/Init";
import DashboardRouter from './views/Dashboard/DashboardRouter';

function App() {
    const [movePage, setMovePage] = useState("");

    const ProtectedRoute = ({ children }) => {
        const userId = sessionStorage.getItem("userId");
        return userId ? children : <Navigate to="/login" replace />;
    };
    
    return (
        <BrowserRouter>
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path="/" element={<ProtectedRoute><Navigate to="/dashboard" /></ProtectedRoute>} />
                    <Route path="/init/admin/:date" element={<Init />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/dashboard" element={<ProtectedRoute><DashboardRouter setMovePage={setMovePage} /></ProtectedRoute>} />
                    <Route path="/group" element={<ProtectedRoute><GroupPage setMovePage={setMovePage} /></ProtectedRoute>} />
                    <Route path="/product" element={<ProtectedRoute><ProductPage setMovePage={setMovePage} /></ProtectedRoute>} />
                    <Route path="/serviceuser" element={<ProtectedRoute><ServiceUserPage setMovePage={setMovePage} /></ProtectedRoute>} />
                    <Route path="*" element={<ProtectedRoute><Navigate to="/dashboard" /></ProtectedRoute>} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}

export default App;